import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/gifs/success.gif'


const _hoisted_1 = { class: "wrapper mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      class: "image mx-auto success-gif",
      src: _imports_0
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "bold-text is-size-4 mb-3" }, "Thank you!", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "is-size-6-mobile is-size-5-tablet" }, "You’ve successfully registered to receive Puls leads. When leads become available, we will send them via email to the email address that you registered with. You’ll have the opportunity to accept/decline. Please let us know if there are any questions", -1)),
    _createElementVNode("button", {
      class: "button is-primary my-6 bold-text is-fullwidth mx-auto",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.done && _ctx.done(...args)))
    }, _toDisplayString(_ctx.btnLabel), 1)
  ]))
}